module.exports = __webpack_public_path__ + "static/media/meteor-dribbble-2.c7234d75.jpg";